export default __webpack_public_path__ + "aerosleep-logo.804d8d6.svg";